<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="150px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="类型：">
            <el-select v-model="dataForm.Type" placeholder="请选择">
                <el-option
                v-for="item in TypeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="banner图："  v-if="dataForm.Type === 1">
          <p>支持png/jpg/jpeg格式，建议尺寸1920*1160</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            drag
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            @onExceed="onExceed"
            :limit="1"
            :fileList="pictureList"
            :class="{ hidePic: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content" >
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="视频："  v-if="dataForm.Type === 2">
            <el-upload
            class="upload-demo"
            drag
            :action="apiAtion"
            :file-list="videoList"
            :limit="1"
            :headers="headers"
            accept=".mp4"
            :on-success="handleVideoSuccess"
            :before-upload="beforeUploadVideo"
            :on-remove="handleVideoRemove"
            :on-exceed="onExceed"
            >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
        </el-form-item>
        <el-form-item label="视频封面图："  v-if="dataForm.Type === 2">
          <p>支持png/jpg/jpeg格式，建议尺寸1920*1160</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            drag
            @onPreview="onPreviewVideoImg"
            @onRemove="onRemoveVideoImg"
            @onUpLoad="onUpLoadVideoImg"
            @onExceed="onExceed"
            :limit="1"
            :fileList="videoPictureList"
            :class="{ hideVideoImg: hideUploadVideoEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content" >
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVideoVisible" :append-to-body="true">
            <img width="100%" :src="dialogVideoImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="排序号：" prop="Sort">
          <el-input-number v-model="dataForm.Sort" :min="0" :max="100" size="small"></el-input-number>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import store from "@/store";
export default {
    name: "edit",
    props: {
        dataForm: {
            type: Object,
            default: null,
        },
        formTitle: {
            type: String,
            default: "",
        },
        headers: {
            type: Object,
            default() {
                return {
                "OF-Authorization": store.getters.GetUserToken,
                };
        },
        }
    },
    data() {
        return {
            TypeOption: [
                {label: '图片',value: 1},
                {label: '视频',value: 2}
            ],
            editFormRules:{
                sort: [
                    {
                        required: true,
                        message: '排序号不能为空',
                        trigger: 'blur'
                    }
                ],
            },
            isConfirm: false,
            width: "60%",
            hideUploadEdit: false,
            pictureList: [],
            dialogImageUrl: '',
            dialogVisible: false,
            limitNum: 1,
            apiAtion: api.FileUpload,
            videoList: [],
            hideUploadVideoEdit: false,
            videoPictureList: [],
            dialogVideoVisible: false,
            dialogVideoImageUrl: ''
        }
    },
    components: {
        OfDialog,
        OfUpload
    },
    mounted() {
        let vm = this
        vm.getImg()
        vm.getVideoImg()
    },
    methods: {
        handleVideoSuccess(res,file) {
            let vm = this
            if(res.Code === 0) {
                vm.dataForm.FileId = file.response.Data.FileId;
                vm.dataForm.url = '/files' + file.response.Data.StorePath;
                vm.dataForm.FileName = file.response.Data.FullName;
                vm.$message({
                    message: "视频上传成功",
                    type: "success",
                });
            } else {
                this.$message.error("视频上传失败，请重新上传！");
            }
        },
        beforeUploadVideo(file) {
            var fileSize = file.size / 1024 / 1024 < 100;
            if (
                [
                "video/mp4"
                ].indexOf(file.type) == -1
            ) {
                this.$message({
                message: "请上传正确的视频格式",
                type: "error"
                });
                return false;
            }
            if (fileSize == false) {
                this.$message({
                message: "视频大小不能超过100MB",
                type: "error"
                });
                return false;
            }
        },
        handleVideoRemove(file,fileList) {
            let vm = this
            vm.dataForm.FileId = null
            vm.dataForm.File = null
            vm.dataForm.FileName = null
            vm.videoList = []
        },
        loadData() {
            const vm = this;
            vm.getImg()
        },
        //取消
        cancel() {
            this.$emit("formCallBack", null);
        },
        confirm() {
            let vm = this
            if (vm.dataForm.Url === "") {
                if (vm.dataForm.Type === 1) {
                    this.$message({
                    message: "请上传图片",
                    type: "error",
                    });
                }else {
                    this.$message({
                    message: "请上传视频",
                    type: "error",
                    });
                }
                return false
            }
            if (vm.dataForm.Type === 2) {
                if (vm.dataForm.VideoImg === "" || vm.dataForm.VideoImg === null || vm.dataForm.VideoImg === undefined) {
                    this.$message({
                    message: "请上传视频封面图",
                    type: "error",
                    });
                    return false
                }
            }
            vm.$refs.form.validate((valid) => {
                if (valid) {
                this.isConfirm = true;
                let params = Object.assign({}, this.dataForm);
                api.SaveSlideSetting(params)
                    .then((rep) => {
                    this.isConfirm = false;
                    if (rep.data.Code === 0) {
                        this.$message({
                        message: "提交成功",
                        type: "success",
                        });
                        this.$emit("formCallBack", params);
                    } else {
                        this.$message({
                        message: rep.data.Message,
                        type: "error",
                        });
                    }
                    })
                    .catch((e) => {
                    this.isConfirm = false;
                    this.$message({
                        message: e.toString(),
                        type: "error",
                    });
                    });
                }
            });
        },
        //查看图片
        onPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //删除封面图
        onRemove() {
            this.pictureList = [];
            this.dataForm.File = null;
            this.dataForm.FileId = null;
            this.dataForm.FileName = null;
            this.hideUploadEdit = false;
        },
        //上传封面图
        onUpLoad(file) {
            if (file.response.Code === 0) {
                this.dataForm.FileId = file.response.Data.FileId;
                this.dataForm.url = '/files' + file.response.Data.StorePath;
                this.dataForm.FileName = file.response.Data.FullName;
                this.$message({
                    message: "banner图上传成功",
                    type: "success",
                });
                this.hideUploadEdit = true;
            }
        },
        onExceed() {
            this.$message({
                message: `只能选择 ${this.limitNum} 个文件`,
                type: "error",
            });
        },
        onPreviewVideoImg(file) {
            this.dialogVideoImageUrl = file.url;
            this.dialogVideoVisible = true
        },
        onRemoveVideoImg() {
            this.videoPictureList = []
            this.dataForm.VideoImg = null
            this.hideUploadVideoEdit = false
        },
        onUpLoadVideoImg(file) {
            if (file.response.Code === 0) {
                this.dataForm.VideoImg = '/files' + file.response.Data.StorePath
                this.$message({
                    message: "视频封面图上传成功",
                    type: "success",
                });
            }
            this.hideUploadVideoEdit = true
        },
        getImg() {
            const vm = this
            if (
                vm.dataForm.Id === undefined ||
                vm.dataForm.Id === null ||
                vm.dataForm.Id == ""
            ) {
                return;
            }
            if (vm.dataForm.Type === 1) {
                vm.hideUploadEdit = true;
                vm.pictureList[0]={
                    url:vm.dataForm.Url
                }

                // vm.$http
                //     .get("/Sys/File/Download?Id=" + vm.dataForm.Id)
                //     .then((res) => {
                //     let pictureList = [res.config];
                //     vm.pictureList = pictureList.map((item) => {
                //         return {
                //         url: item.url,
                //         };
                //     });
                // });
            }else {
                let videoList = []
                const obj = {
                    url: this.dataForm.Url,
                    name: this.dataForm.FileName
                };
                videoList.push(obj)
                vm.videoList = videoList
            }
        },
        getVideoImg() {
            const vm = this
            if (vm.dataForm.VideoImg === undefined || vm.dataForm.VideoImg === null || vm.dataForm.VideoImg === ""){
                return
            }
            if (vm.dataForm.Type === 2) {
                vm.hideUploadVideoEdit = true
                const obj = {
                    url: vm.dataForm.VideoImg
                }
                vm.videoPictureList.push(obj)

            }
        }
    }
}

</script>
<style scoped lang="scss">
/deep/ .upload-demo  .el-upload input[type="file"] {
  display: none !important;
}

/deep/ .hidePic .el-upload--picture-card {
    display: none;
}
/deep/ .hideVideoImg .el-upload--picture-card {
    display: none;
}
</style>
